@if (content && slides && slides.length) {
  <div [ngClass]="size">
    @if (type == 'multi') {
      <wagtail-page-element-full-bleed-slider-multi
        [slides]="slides"
      ></wagtail-page-element-full-bleed-slider-multi>
    }
    @if (type == 'single') {
      <wagtail-page-element-full-bleed-slider-single
        [slide]="slides[0]"
      ></wagtail-page-element-full-bleed-slider-single>
    }
  </div>
}
